import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Linkedin, Facebook, Instagram, MapPin, Mail } from 'lucide-react';
import './components.css';

export default function Footer() {
    const navigate = useNavigate();
    const location = useLocation();
    // The full (multi-column) footer shows on every page that can be viewed without
    // logging in — the public marketing + auth pages — not just the landing page.
    const PUBLIC_FOOTER_PATHS = new Set([
        '/', '/home', '/login', '/signup', '/about', '/contact',
        '/terms', '/privacy', '/forgot-password', '/reset-password',
        '/verify-email', '/unauthorized',
    ]);
    const showFullFooter = PUBLIC_FOOTER_PATHS.has(location.pathname);

    // "Packages" jumps to the premium tiers section on the landing page.
    const goToPackages = (e) => {
        e.preventDefault();
        navigate('/');
        setTimeout(() => {
            const el = document.getElementById('packages');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 120);
    };

    // Logo returns to the top of the homepage.
    const goToHomeTop = (e) => {
        e.preventDefault();
        navigate('/');
        setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 120);
    };

    const colHeading = { fontSize: '1.1rem', fontWeight: 700, color: '#1f2937', marginBottom: '1rem' };
    const socialIconStyle = { color: '#4b5563', display: 'inline-flex', alignItems: 'center' };

    return (
        <footer style={{ backgroundColor: '#ffffff', borderTop: '1px solid #e5e7eb', marginTop: '3rem' }}>
            {showFullFooter && (
                <div className="container py-5">
                    <div className="row gy-4">
                        {/* Brand */}
                        <div className="col-md-3">
                            <a href="/" onClick={goToHomeTop} aria-label="Kobra Prep home">
                                <img src="/kobraprep-logo.png" alt="Kobra Prep" style={{ height: '56px', width: 'auto', cursor: 'pointer' }} />
                            </a>
                            <p style={{ color: '#7c3aed', marginTop: '0.75rem', fontWeight: 700, fontStyle: 'italic' }}>Lets Kill The Exam.</p>
                        </div>

                        {/* Packages */}
                        <div className="col-md-3">
                            <h5 style={colHeading}>Packages</h5>
                            <a href="/" onClick={goToPackages} className="kp-footer-link">Packages</a>
                        </div>

                        {/* Support */}
                        <div className="col-md-3">
                            <h5 style={colHeading}>Support</h5>
                            <Link to="/about" className="kp-footer-link">About Us</Link><br />
                            <Link to="/contact" className="kp-footer-link">Contact Us</Link><br />
                            <Link to="/terms" className="kp-footer-link">Terms &amp; Condition</Link><br />
                            <Link to="/privacy" className="kp-footer-link">Privacy Policy</Link>
                        </div>

                        {/* Contact */}
                        <div className="col-md-3">
                            <h5 style={colHeading}>Our Contact:</h5>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', color: '#4b5563', marginBottom: '0.9rem' }}>
                                <MapPin size={18} style={{ flexShrink: 0, marginTop: 2 }} />
                                <span>Santa Clara, California.</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', color: '#4b5563', marginBottom: '0.9rem' }}>
                                <Mail size={18} style={{ flexShrink: 0, marginTop: 2 }} />
                                <a href="mailto:support@kobraprep.com" style={{ color: '#4b5563', textDecoration: 'none' }}>support@kobraprep.com</a>
                            </div>
                            <div style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem' }}>
                                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" style={{ ...socialIconStyle, color: '#0A66C2' }}>
                                    <Linkedin size={20} />
                                </a>
                                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={{ ...socialIconStyle, color: '#1877F2' }}>
                                    <Facebook size={20} />
                                </a>
                                <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={{ ...socialIconStyle, color: '#E4405F' }}>
                                    <Instagram size={20} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div style={{ borderTop: '1px solid #e5e7eb' }}>
                <p style={{ textAlign: 'center', color: '#6b7280', padding: '1.25rem 0', margin: 0, fontWeight: 500 }}>
                    Copyright © 2026 Kobra Prep. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
}
